import { useCallback, useMemo } from 'react';

import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { Button } from 'UIPackage/MainModule/components/Button';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';

import styles from './KnmHeaderComplete336Modal.module.scss';

interface IComplete336ModalProps {
  visible?: boolean;
  id?: number;
  isErp?: boolean;
  onApply: (knoId?: number) => void;
  onClose: () => void;
}

export const KnmHeaderComplete336Modal = ({ visible, id, isErp, onApply, onClose }: IComplete336ModalProps) => {
  const handleApplyButtonClick = useCallback(() => {
    onApply(id);
    onClose();
  }, [id, onApply, onClose]);

  const renderTitle: string = useMemo(() => {
    return isErp ? 'Подтверждение смены статуса проверки' : 'Подтверждение смены статуса КНМ';
  }, [isErp]);

  const renderConfirmation = useMemo(() => {
    return isErp
      ? 'Вы хотите отменить проведение проверки и изменить её статус на «Завершено»?'
      : 'Вы хотите отменить проведение КНМ и изменить статус КНМ на «Завершено»?';
  }, [isErp]);

  if (!visible) {
    return null;
  }

  return (
    <Modal visible={visible} modalBodyClassName={styles.ModalBody} onClose={onClose}>
      <ModalHeader title={renderTitle} sizeText="small" />
      <ModalBody size="content" border="bottom" overflow-y="hidden">
        <>
          <h2 className={styles.TitleBody}>Уважаемый пользователь!</h2>
          <div className={styles.BodyText}>
            <p>
              Изменение данных в КНМ после его завершения будет недоступно. Перед выполнением действия по завершению КНМ
              по ПП336, выполните сохранение изменений путем нажатия на кнопку «Сохранить».
            </p>
            <p>
              Действие по завершению КНМ по ПП336 является необратимым и является отменой проведения КНМ на основании
              постановления Правительства Российской Федерации от 10 марта 2022 г. № 336 «Об особенностях организации и
              осуществления государственного контроля (надзора), муниципального контроля».
            </p>
          </div>
          <div className={styles.BodyText}>{renderConfirmation}</div>
        </>
      </ModalBody>
      <ModalActions>
        <Button text="Да" color="primary" size="medium" onClick={handleApplyButtonClick} />
        <Button text="Нет" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
